<template>

    <v-modal title="Condition">

        <template #body>
            <v-alert :message="error" />
            <v-form-group dir="ver" label="Condition">
                <v-select :model="params.condition || ''" @input="params.condition = $event">
                    <option value="">Select Condition</option>
                    <option value="event">If performed event</option>
                    <option value="no-event">If did not perform event</option>
                    <option value="segment">If is in segment</option>
                    <option value="no-segment">If is not in segment</option>
                </v-select>
            </v-form-group>
            <v-form-group v-if="['event', 'no-event'].includes(params.condition)" dir="ver" label="Event">
                <v-select :model="params.event_id || ''" @input="params.event_id = $event">
                    <option value="">Select Event</option>
                    <option v-for="event in events" :key="event.id" :value="event.id">{{ event.name }}</option>
                </v-select>
            </v-form-group>
            <v-form-group v-if="['segment', 'no-segment'].includes(params.condition)" dir="ver" label="Segment">
                <v-select :model="params.segment_id || ''" @input="params.segment_id = $event">
                    <option value="">Select Segment</option>
                    <option v-for="segment in segments" :key="segment.id" :value="segment.id">{{ segment.name }} ({{ segment.customers_count | numeral('0,0') }})</option>
                </v-select>
            </v-form-group>
            <v-form-group v-if="['event', 'no-event'].includes(params.condition)" dir="ver" label="In the past">
                <v-delay-picker :model="params.since" @input="params.since = $event" />
            </v-form-group>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="saveAction">Save</v-button>
        </template>

    </v-modal>

</template>

<script>

import ModalActionMixin from '@mixins/ModalActionMixin';

export default {

    mixins: [ModalActionMixin],

    data() {
        return {
            params: {
                type: this.action.type,
                condition: this.action.condition,
                segment_id: this.action.segment_id,
                event_id: this.action.event_id,
                since: this.action.since,
            },
        }
    },

    computed: {

        segments() {
            return this.$store.getters.project.segments;
        },

        events() {
            return this.$store.getters.project.events;
        },

    },

}

</script>
